import NavContent from "./Components/NavContent"
import Back from "./Components/Back"
import LiquidGlass from "../Style/LiquidGlass"
export default function Container({items = []}) {
  return (
    <LiquidGlass tag="nav" rounded="2xl" className="h-fit py-3 pr-5 flex border border-zi-blue-light dark:border-none rounded-2xl drop-shadow-md bg-zi-bg2-light dark:bg-zi-inputbg-dark/50" childrenClassName="w-full flex items-center justify-between gap-3">
      <NavContent items={items}/>
      <Back/>
    </LiquidGlass>
  )
}